import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "z-0 absolute grid grid-rows-2 grid-cols-2 w-screen h-72 md:overflow-hidden md:h-screen" }
const _hoisted_2 = { class: "relative w-full h-full" }

import { Events, useSubscribe } from "@/utils/conductor";
import { ref, reactive, computed } from "vue";
import BackgroundBubble from "../atoms/BackgroundBubble.vue";

interface CircleData {
  active: boolean;
  position: { x: number; y: number };
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const circles = ref<CircleData[][]>([]);
const activeCircle = reactive({
  set: -1,
  idx: -1,
});

function initCircles() {
  const circlesSet: CircleData[][] = [];
  for (const setIdx of [...Array(4).keys()]) {
    const nbCircles = Math.ceil(Math.random() * 3);
    const cornerCircles: CircleData[] = [];
    for (let circleIdx = 0; circleIdx < nbCircles; circleIdx++) {
      cornerCircles.push(
        reactive({
          active: computed(
            () => activeCircle.set === setIdx && activeCircle.idx === circleIdx
          ),
          position: { x: Math.random(), y: Math.random() },
        })
      );
    }
    circlesSet.push(cornerCircles);
  }

  circles.value = circlesSet;

  useSubscribe(Events.synth, () => {
    for (const circleSet of circles.value) {
      for (const circle of circleSet) {
        circle.position = { x: Math.random(), y: Math.random() };
      }
    }
  });

  useSubscribe(Events.clarinet, () => {
    // Pick a random circle
    let circleSetIdx = activeCircle.set;
    let circleIdx = activeCircle.idx;
    while (
      circleSetIdx === activeCircle.set &&
      circleIdx === activeCircle.idx
    ) {
      circleSetIdx = Math.floor(Math.random() * circles.value.length);
      const circleSet = circles.value[circleSetIdx];
      circleIdx = Math.floor(Math.random() * circleSet.length);
    }

    // Set active circle
    activeCircle.set = circleSetIdx;
    activeCircle.idx = circleIdx;
  });
}
initCircles();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(circles.value, (corner, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: ""
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(corner, (circle, ci) => {
            return (_openBlock(), _createBlock(BackgroundBubble, {
              key: ci,
              position: circle.position,
              active: circle.active
            }, null, 8, ["position", "active"]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}
}

})